import { extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

// install rules for vee-validate
Object.keys(rules).forEach(rule => {
  extend(rule, (rules as { [key: string]: any })[rule]);
});

localize({
  en
});

localize("en");
